export const EMPTY_CLIENT_NAME = '';
export const EMPTY_ORIGIN = '';

export const ALL_ORIGINS = '*';

export function isAllowedOriginSet(allowedOriginDomains: string[] | undefined) {
  if (allowedOriginDomains === undefined) {
    return false;
  }
  if (allowedOriginDomains.length === 0) {
    return false;
  }
  if (allowedOriginDomains.length === 1 && allowedOriginDomains[0] === '') {
    return false;
  }
  return true;
}

export function allOriginsAllowed(allowedOriginDomains: string[] | undefined) {
  return allowedOriginDomains?.includes(ALL_ORIGINS);
}

function isSPARiskNotAcknowledged(isSetupForSPA: boolean, hasAcceptedSPARisk: boolean) {
  return isSetupForSPA && !hasAcceptedSPARisk;
}

function isExpiryRiskNotAcknowledged(expirationDisabled: boolean, hasAcceptedExpiryRisk: boolean) {
  return expirationDisabled && !hasAcceptedExpiryRisk;
}

export function validateClientForm(
  clientName: string,
  isSetupForSPA: boolean,
  hasAcceptedSPARisk: boolean,
  expirationDisabled: boolean,
  hasAcceptedExpiryRisk: boolean,
): boolean {
  if (clientName === EMPTY_CLIENT_NAME) {
    return false;
  }
  if (isSPARiskNotAcknowledged(isSetupForSPA, hasAcceptedSPARisk)) {
    return false;
  }
  if (isExpiryRiskNotAcknowledged(expirationDisabled, hasAcceptedExpiryRisk)) {
    return false;
  }
  return true;
}
